/*
Akhila 12/26/2022 3075154998 Added Add Rule Popup
Akhila 12/28/2022 3075154998 Added Add  Action popUp and Added Fields
Sohel 12/28/2022 3075154998 Condition Table Changes
Lalitha 12/29/2022 3075154998 Changed defaut value to AND
Sohel 12/29/2022 3075154998 Added props
Akhila 12/30/2022 3075154998 Added Field Validation
Sohel 01/02/2022 2698964415 pass condition deleted ids in payload
sai krisha 01/06/2023 2698964415  AND OR auto populate functionality
kavyareddy 01/10/2023 2698964415 Fixed label issues
Sohel 01/17/2023 2701334326 removed validation
sai krisha 01/17/2023 2698964415 added preprocessor name for delete popup
Sohel 01/19/2023 2698964415 dialog box Message Changes
Sohel 01/23/2023 3075154998 Added code based on Condition
Sohel 01/23/2023 3075154998 check syntax payload changes
Ravi 03/08/2023 3075154998 rename Add Preprocessor to Add Data Transformation
Sohel 03/24/2023 3075154998 renamed labels
Dilip 03/28/2023 3075154998 Fixed delete id's in save api payload issue.
Prakash 03/29/2023 3075154998 Added position and  margin spacing.
Sohel 04/19/2023 2698964415 Added Error Record in Exports
Akhila 04/24/2023 2698964415 bug fixed and prepoulated data
Sohel 05/30/2023 2698964415 Fixed Accordion Bugs
Sohel 05/30/2023 2698964415 Fixed Accordion Bugs
Sohel 05/30/2023 2698964415 Fixed Accordion id issue
Sohel 05/30/2023 2698964415 Fixed Accordion id issue
Sohel 05/31/2023 2698964415 Transformation Accordion id issue
*/

import React, {useContext, useState, useEffect, useRef} from 'react';
import {
  Button,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import DMRActionTable from './DMRActionTable';
import {withField} from '../../../../../util/withField';
import {Draggable} from 'react-beautiful-dnd';
import ConditionsTable from './ConditionsTable';
import {ErrorMessage} from '../../../../../util/ErrorMessage';
import DMRaddRule from './DMRaddRule';
import DialogBox from '../../../../../components/DialogBox';
import {useDispatch} from 'react-redux';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';

import {
  fetchAllFunctions,
  getOperatorsDropdownData,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';

const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    'margin': '10px 0px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '12px',
    },
    '& .MuiAccordion-root': {
      borderRadius: '0px !important',
    },
  },
  accordionDetailsStyling: {
    border: '1px solid #0000003b !important',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
    marginLeft: 8,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    backgroundColor: '#fff',
  },
}));
const PreProcessor = (props) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const [isEditMode, setIsEditMode] = useState(false);
  const [ruleGroupSNo, setRuleGroupSNo] = useState(1);
  const [formData, setFormData] = useState([]);
  const [oldRuleCode, setOldRuleCode] = useState('');
  const [rowData, setRowData] = useState({});
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
    setRuleGroupSNo(value.condition?.length);
  };
  const [open, setOpen] = useState(false);

  const [isActionEditMode, setIsActionEditMode] = useState(false);
  const [actionformData, setActionFormData] = useState([]);
  const [actionRowData, setActionRowData] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  // prepProcessorGroupData?.dmProcessorRequestList[0]?.isDataTransformation ||
  // value?.isDataTransformation === "Y"
  //   ? true
  //   : "N"
  //   ? false
  //   : "";
  const resultRef = useRef();
  const {
    index,
    name,
    value,
    setFieldValue,
    handleChange,
    expanded,
    conditionDeletedIds,
    actionDeleteIdsRef,
    arrayHelpers,
    processorDeleteRef,
    managerRecordGroup,
    exportManagerRecord,
    handleBlur,
    dataTranformationData,
    handleAccordionChange,
  } = props;
  const draggableIds = index.toString();
  const isDataTransformation = ['Y', true]?.includes(value?.isDataTransformation) ? true : false;
  useEffect(() => {
    dispatch(fetchAllFunctions());
    dispatch(getOperatorsDropdownData());
  }, []);
  const handleValueChange = (name, value) => {
    setFieldValue(name, value);
  };
  const conditionalProps = {
    name: name,
    value: value,
    handleValueChange: handleValueChange,
    resultRef,
    exportManagerRecord,
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    arrayHelpers.remove(index);
    processorDeleteRef.current.push(value?.dmProcessorId);
    handleCloseDialog();
  };
  return (
    <>
      <Draggable draggableId={draggableIds || ''} index={index} key={index}>
        {(provided, snapshot) => (
          <div
            className={classes1.root}
            {...provided.draggableProps}
            ref={provided.innerRef}
            key={index}
          >
            <Accordion
              className="accordion-styling"
              elevation={0}
              expanded={expanded === `panel1${index}`}
              onChange={handleAccordionChange(`panel1${index}`)}
            >
              <AccordionSummary
                // aria-controls="panel2bh-content"
                // id="panel2bh-header"
                aria-controls={'panel' + {index} + 'd - content'}
                id={'panel' + {index} + 'd-header'}
                className={classes1.accordionDetailsStyling}
                IconButtonProps={{edge: 'start'}}
              >
                <div className="d-flex justify-content-between w-100">
                  <div>
                    {expanded === `panel1${index}` ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    <span
                      style={{
                        backgroundColor: '#61ff8c',
                        padding: '7px 16px',
                        borderRadius: '25px',
                        fontWeight: 'bold',
                      }}
                    >
                      Data Transformation-{index + 1}
                    </span>
                  </div>
                  <div style={{display: 'flex'}}>
                    <div {...provided.dragHandleProps}>
                      <Tooltip title="Drag">
                        <DragIndicatorIcon />
                      </Tooltip>
                    </div>
                    <Tooltip title="Delete">
                      <IconButton
                        className="py-0"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsDelete(true);
                        }}
                      >
                        <DeleteOutlined />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
                <Typography>{}</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes1.detailsCard}>
                <div className="form-row global-field-textfields new-standard-textfields  ">
                  <div className={`col-sm-6 col-md-4  col-xl-3 form-group mt-3`}>
                    <TextField
                      className={` ${classes.labelName} w-100`}
                      placeholder="Enter Data Transformation"
                      margin="dense"
                      name={`${name}.preprocessorName`}
                      value={value?.preprocessorName || ''}
                      required
                      onBlur={handleBlur}
                      disabled={isDataTransformation}
                      onChange={(e) => {
                        handleValueChange(`${name}.preprocessorName`, e.target.value);
                      }}
                      variant="outlined"
                      label=" Data Transformation"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    <ErrorMessage
                      render={(msg) => (
                        <div style={{color: 'red', position: 'absolute'}}>{msg}</div>
                      )}
                      name={`${name}.preprocessorName`}
                    />
                  </div>
                </div>

                <div className="custom-table global-field-table processor-table">
                  <div className="table-header table-card-header new-standard-textfields justify-content-between">
                    <Typography variant="h3">Conditions: </Typography>
                    <Button
                      variant="outlined"
                      className={`search-btn ${classes.buttonRoot}`}
                      disabled={isDataTransformation}
                      onClick={() => {
                        setOpen(true);
                        // const reqNo =
                        //   value?.conditions?.length > 0
                        //     ? Number(
                        //         value?.conditions[value?.conditions?.length - 1].ruleCode?.slice(1)
                        //       ) + 1
                        //     : value?.conditions?.length + 1;
                        // setRuleGroupSNo(reqNo);
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Condition
                    </Button>
                  </div>
                  <ConditionsTable
                    setFormData={setFormData}
                    formData={formData}
                    isEditMode={isEditMode}
                    setIsEditMode={setIsEditMode}
                    setRowData={setRowData}
                    setOldRuleCode={setOldRuleCode}
                    conditionalProps={conditionalProps}
                    conditionDeletedIds={conditionDeletedIds}
                    dataTranformationData={dataTranformationData}
                  />
                </div>
                <div className="new-standard-textfields">
                  <RadioGroup
                    aria-label="resultExpCondition"
                    name={`${name}.resultExpCondition`}
                    value={value.resultExpCondition}
                    disabled={isDataTransformation}
                    onChange={(e) => {
                      handleChange(e);
                      const result = value?.conditions?.map((el, i) => el.ruleCode);
                      resultRef.current = false;
                      setFieldValue(`${name}.result`, result.join(` ${e.target.value} `));
                    }}
                    style={{
                      display: 'flex',
                      justifyContent: 'start',
                      flexDirection: 'row',
                    }}
                  >
                    <FormControlLabel
                      classname="select-radio-tab"
                      value="AND"
                      control={<Radio />}
                      label="AND"
                      disabled={value.resultExpCondition == '' || isDataTransformation}
                    />
                    <FormControlLabel
                      classname="select-radio-tab"
                      value="OR"
                      control={<Radio />}
                      label="OR"
                      disabled={value.resultExpCondition == '' || isDataTransformation}
                    />
                  </RadioGroup>
                </div>
                <div className="form-row global-field-textfields new-standard-textfields">
                  <div className="col-sm-6 col-lg-8 form-group">
                    <TextField
                      className={` ${classes.labelName} w-100`}
                      placeholder="Enter Result"
                      margin="dense"
                      name="result"
                      variant="outlined"
                      label="Result Expression"
                      disabled={isDataTransformation}
                      value={value.result}
                      onChange={(e) => {
                        // setResultSql(e.target.value);
                        if (e.target.value.length > 0) {
                          resultRef.current = true;
                          setFieldValue(`${name}.resultExpCondition`, '');
                        }
                        setFieldValue(`${name}.result`, e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                </div>

                <DMRActionTable
                  setActionFormData={setActionFormData}
                  actionformData={actionformData}
                  isActionEditMode={isActionEditMode}
                  setIsActionEditMode={setIsActionEditMode}
                  setActionRowData={setActionRowData}
                  conditionalProps={conditionalProps}
                  actionRowData={actionRowData}
                  actionDeleteIdsRef={actionDeleteIdsRef}
                  managerRecordGroup={managerRecordGroup}
                  exportManagerRecord={exportManagerRecord}
                />
              </AccordionDetails>
            </Accordion>
          </div>
        )}
      </Draggable>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Transformation"
        value={`Are you sure you want to delete this Transformation ${index + 1} ?`}
        handleSubmit={handleSubmit}
        deleteRecord={value}
      />
      <DialogBox
        open={open || isEditMode}
        dialogClose={handleClose}
        hideFooter={true}
        maxWidth={'xl'}
        title={(isEditMode && 'Add Condition ') || (open && 'Add Condition')}
      >
        <DMRaddRule
          rowData={rowData}
          // setFormData={setFormData}
          // formData={formData}
          setOpen={setOpen}
          handleClose={handleClose}
          isEditMode={isEditMode}
          oldRuleCode={oldRuleCode}
          setIsEditMode={setIsEditMode}
          ruleGroupSNo={ruleGroupSNo}
          conditionalProps={conditionalProps}
          managerRecordGroup={managerRecordGroup}
        />
      </DialogBox>
    </>
  );
};

export default withField(PreProcessor);
